import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import Landing from './pages/Landing';
import Login from './pages/Login';
import OAuthSelection from './pages/OAuthSelection';
import InstagramAuth from './pages/InstagramAuth';
import Dashboard from './pages/Dashboard';
import Messages from './pages/Messages';
import Comments from './pages/Comments';
// Temporarily hidden
// import AutoReplies from './pages/AutoReplies';
import ChatGptPrompts from './pages/ChatGptPrompts';
import PromptTester from './pages/PromptTester';
import Settings from './pages/Settings';
import Contacts from './pages/Contacts';
import HelpCenter from './pages/HelpCenter';
import Checkout from './pages/Checkout';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import CookiePolicy from './pages/CookiePolicy';
import FAQ from './pages/FAQ';
import ContactUs from './pages/ContactUs';
import PublicHelpCenter from './pages/PublicHelpCenter';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: '"Lexend", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Lexend", sans-serif',
      fontWeight: 700,
    },
    h2: {
      fontFamily: '"Lexend", sans-serif',
      fontWeight: 600,
    },
    h3: {
      fontFamily: '"Lexend", sans-serif',
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"Lexend", sans-serif',
      fontWeight: 500,
    },
    h5: {
      fontFamily: '"Lexend", sans-serif',
      fontWeight: 500,
    },
    h6: {
      fontFamily: '"Lexend", sans-serif',
      fontWeight: 400,
    },
    body1: {
      fontFamily: '"Lexend", sans-serif',
      fontWeight: 400,
    },
    body2: {
      fontFamily: '"Lexend", sans-serif',
      fontWeight: 400,
    },
    button: {
      fontFamily: '"Lexend", sans-serif',
      fontWeight: 500,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/help-center" element={<PublicHelpCenter />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/login" element={<Login />} />
            <Route path="/oauth-selection" element={<PrivateRoute><OAuthSelection /></PrivateRoute>} />
            <Route path="/app" element={<PrivateRoute><Layout /></PrivateRoute>}>
              <Route index element={<Navigate to="/app/dashboard" replace />} />
              <Route path="instagram-auth" element={<PrivateRoute><InstagramAuth /></PrivateRoute>} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="messages" element={<Messages />} />
              <Route path="comments" element={<Comments />} />
              <Route path="contacts" element={<Contacts />} />
              {/* Temporarily hidden */}
              {/* <Route path="autoreplies" element={<AutoReplies />} /> */}
              <Route path="chatgpt-prompts" element={<ChatGptPrompts />} />
              <Route path="prompt-tester" element={<PromptTester />} />
              <Route path="help-center" element={<HelpCenter />} />
              <Route path="settings" element={<Settings />} />
              <Route path="checkout" element={<Checkout />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
